import React from 'react';

import autoBind from 'react-autobind';
import DateFnsUtils from '@date-io/date-fns';
import { If, Then, Else } from 'react-if'

import Helper from "../../Helper.jsx"
import Localization from "../../Localization.jsx"

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, Divider, Grid, Tooltip, IconButton, Icon, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, Typography, FormControl, Select, MenuItem, InputLabel  } from '@material-ui/core';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { isThisQuarter } from 'date-fns/esm';
import { addYears } from 'date-fns';

const MAX_ROW_PER_PAGE = 12;

class AdminViewUserSubscription extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();
    // const [date, changeDate] = useState(new Date());
    // state variables here
    this.state = {
      open: false,
      activeTab: 0,
      date: new Date(),
      user_id: "",
      subscriptionType: 0,
      subscriptionStartDate: new Date(),
      subscriptionEndDate: addYears(new Date(), 2),
      subscriptionHistoryList: [],
      highlighted_id: 0,
    };
    autoBind(this);
  }

  close() {
    this.setState({ open: false });
    this.state.open = false;
  }

  refreshSubscriptionHistoryList(){
    console.log("refreshSubscriptionHistoryList");

    var requestObj = {
      user_id: this.state.user_id
    }

    this.props.root.refs.API.request("get_user_subscription_list", requestObj, this.getUserSubscriptionListOK, this.getUserSubscriptionListFailed);

  }

  getUserSubscriptionListOK(res){
    console.log("getUserSubscriptionListOK");
    console.log(res);

    this.setState({
      subscriptionHistoryList: res.body['result'],
    });
    this.state.subscriptionHistoryList = res.body['result'];
  }

  getUserSubscriptionListFailed(res){
    console.log("getUserSubscriptionListFailed");
  }

  handleSubscriptionStartDateChange(date){
    if(this.state.subscriptionEndDate < date){
      this.props.root.addNotification(Localization.strings.DATE_INVALID_REMINDER);
      return;
    }

    this.setState({subscriptionStartDate: date});
    this.state.subscriptionStartDate = date;
  }

  handleSubscriptionEndDateChange(date){
    let today = new Date();
    if(date < this.state.subscriptionStartDate || date < today){
      this.props.root.addNotification(Localization.strings.DATE_INVALID_REMINDER);
      return;
    }

    this.setState({subscriptionEndDate: date});
    this.state.subscriptionEndDate = date;
  }

  onSubscriptionTypeChanged(e){
    this.setState({ subscriptionType: e.target.value });
    this.state.subscriptionType = e.target.value;
  }

  createNewSubscription(){
    console.log("createNewSubscription");
    console.log(this.state.user_id);
    console.log(Helper.dateToTimestampShort(this.state.subscriptionStartDate));
    console.log(Helper.dateToTimestampShort(this.state.subscriptionEndDate));
    console.log(this.state.subscriptionType);

    // send create subscription request
    var requestObj = {
      user_id: this.state.user_id,
      date_start: Helper.dateToTimestampShort(this.state.subscriptionStartDate),
      date_end: Helper.dateToTimestampShort(this.state.subscriptionEndDate),
      type: this.state.subscriptionType,
    }

    this.props.root.refs.API.request("create_user_subscription", requestObj, this.createSubscriptionOK, this.createSubscriptionFailed);
  }

  createSubscriptionOK(res){
    console.log("createSubscriptionOK");
    console.log(res);

    // refrest subscription list
    this.refreshSubscriptionHistoryList();

    this.props.root.addNotification(Localization.strings.CREATED);
  }

  createSubscriptionFailed(res){
    console.log("createSubscriptionFailed");
    console.log(res);
  }

  onSendReminderClicked(subscription_id){
    console.log("onSendReminderClicked: " + subscription_id.toString());
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'md'}
          onClose={this.close}
        >
          <DialogTitle>
            {this.state.user_id + " Subscription Detail"}
          </DialogTitle>

          <DialogContent>
            <Typography variant="subtitle1">
              Create New Subscription
            </Typography>
            <Grid container>
              <Grid item xs={1}>
                  <Typography variant="subtitle1" align="center" style={{
                      position: 'relative', left: '50%', top: '50%',
                      transform: 'translate(-50%, -50%)'
                  }}>
                    From:
                  </Typography>
              </Grid>
              <Grid item xs={4}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      variant="inline"
                      format="dd/MM/yyyy"
                      margin="normal"
                      id="start-date-picker-inline"
                      value={this.state.subscriptionStartDate}
                      onChange={this.handleSubscriptionStartDateChange}
                    />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={1}>
                  <Typography variant="subtitle1" align="center" style={{
                      position: 'relative', left: '50%', top: '50%',
                      transform: 'translate(-50%, -50%)'
                  }}>
                    To:
                  </Typography>
              </Grid>
              <Grid item xs={4}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  
                    <KeyboardDatePicker
                      variant="inline"
                      format="dd/MM/yyyy"
                      margin="normal"
                      id="start-date-picker-inline"
                      value={this.state.subscriptionEndDate}
                      onChange={this.handleSubscriptionEndDateChange}
                    />
                </MuiPickersUtilsProvider>
              </Grid>
              {/* <Grid item xs={1}>
                <Typography variant="subtitle1" align="center" style={{
                      position: 'relative', left: '50%', top: '50%',
                      transform: 'translate(-50%, -50%)'
                  }}>
                    Type:
                </Typography>
              </Grid> */}
              <Grid item xs={2}>
                <FormControl>
                  <InputLabel style={{width:"130px",display:"Inline-block"}}>Type</InputLabel>
                  <Select
                    value={this.state.subscriptionType}
                    onChange={this.onSubscriptionTypeChanged}
                  >
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <div style={{ display: "flex" }}>
              <Button onClick={this.createNewSubscription} color="primary" variant="contained" style={{ marginLeft: "auto" }}>
                <Icon>add</Icon>
                {Localization.strings.CREATE}
              </Button>
            </div>
          </DialogContent>

          <Divider variant="middle"/>

          <DialogContent>
            <Typography variant="subtitle1">
              Subscription History
            </Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>
                    編號
                  </TableCell>
                  <TableCell>
                    創建日期
                  </TableCell>
                  <TableCell>
                    開始日期
                  </TableCell>
                  <TableCell>
                    結束日期
                  </TableCell>
                  <TableCell>
                    訂閱類型
                  </TableCell>
                  <TableCell>
                    訂閱狀態
                  </TableCell>
                  <TableCell>
                    發送提醒
                  </TableCell>
                </TableRow>
              </TableHead>
              {
                this.state.subscriptionHistoryList.map((row, i) => {
                  return(
                    <TableRow>
                      <TableCell>
                        {row["id"]}
                      </TableCell>
                      <TableCell>
                        {row["date_created"]}
                      </TableCell>
                      <TableCell>
                        {row["date_start"]}
                      </TableCell>
                      <TableCell>
                        {row["date_end"]}
                      </TableCell>
                      <TableCell>
                        {row["type"]}
                      </TableCell>
                      <TableCell>
                        {row["status"] == "ACTIVE"
                          ? <font color="green">{row["status"]}</font>
                          : (row["status"] == "EXPIRED" ? <font color="red">{row["status"]}</font> : <font>{row["status"]}</font>)}
                      </TableCell>
                      <TableCell>
                        <Button
                          disabled={row["status"] == "INACTIVE"}
                          color="primary"
                          size="small"
                          onClick={()=>this.onSendReminderClicked(row["id"])}
                        >
                          <Icon>notifications</Icon>
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })
              }
            </Table>
          </DialogContent>

          <DialogActions style={{padding:'16px 24px'}}>
            <Button
              color="primary"
              variant="contained"
              onClick={this.close}
            >
              {Localization.strings.DONE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default AdminViewUserSubscription;
